import React, { useEffect } from "react";
import { useAppSelector } from "../../hooks/store-hooks";
import { useNavigate } from "react-router-dom";
import { useLazyGetHomeDataQuery } from "../../store/api/homeApi";
import { ONBOARDING_ROUTE_MAPPING, ROUTES } from "../../constants/routes";
import MainLoader from "../../components/common/loader/main-loader";
import HomePage from "../../components/Home";
import { MixpanelEvent, trackEvent } from "../../analytics/mixpanel";

const Home = () => {
  const navigate = useNavigate();

  const [{ isFetching }] = useLazyGetHomeDataQuery();

  const { homeData } = useAppSelector((state: any) => state.home);
  const isPageViewTracked = React.useRef(false);
  
  useEffect(() => {
    if (homeData && !homeData?.onboarding?.is_completed) {
      const onboardingRoute =
        homeData?.onboarding?.page_id || ROUTES.ONBOARDING_PERSONAL_DETAILS;
      navigate(ONBOARDING_ROUTE_MAPPING?.[onboardingRoute]);
    }
    else{
      if (isPageViewTracked.current) return;
      trackEvent(MixpanelEvent.PAGE_VIEW, { page_name: "home" });
      isPageViewTracked.current = true;
    }
  }, [homeData]);

  return (
    <div className="h-[100vh] bg-gray-100  w-full">
      {isFetching ? <MainLoader /> : null}
      <HomePage />
    </div>
  );
};

export default Home;
